export const CALCULATED_ECPA = 'calculated_eCPA' as const;
export const CALCULATED_ECPC = 'calculated_eCPC' as const;
export const CALCULATED_ECPI = 'calculated_eCPI' as const;
export const CALCULATED_ECPM = 'calculated_eCPM' as const;

export const CALCULATED_ECPA_IN_LOCAL_CURRENCY = 'calculated_eCPA_in_local_currency' as const;
export const CALCULATED_ECPC_IN_LOCAL_CURRENCY = 'calculated_eCPC_in_local_currency' as const;
export const CALCULATED_ECPI_IN_LOCAL_CURRENCY = 'calculated_eCPI_in_local_currency' as const;
export const CALCULATED_ECPM_IN_LOCAL_CURRENCY = 'calculated_eCPM_in_local_currency' as const;

export const CALCULATED_ROAS = 'calculated_ROAS' as const;
export const CALCULATED_ROI = 'calculated_ROI' as const;

export const EO_CLICK_TO_EO_INSTALL = 'eo_click_to_eo_install' as const;
export const EO_CLICK_TO_EO_REINSTALL = 'eo_click_to_eo_reinstall' as const;
export const EO_CLICK_TO_EO_OPEN = 'eo_click_to_eo_open' as const;
export const EO_CLICK_TO_EO_WEB_SESSION_START = 'eo_click_to_eo_web_session_start' as const;

export const EO_BRANCH_CTA_VIEW_TO_EO_CLICK = 'eo_branch_cta_view_to_eo_click' as const;
export const EO_BRANCH_CTA_VIEW_TO_EO_INSTALL = 'eo_branch_cta_view_to_eo_install' as const;
export const EO_BRANCH_CTA_VIEW_TO_EO_OPEN = 'eo_branch_cta_view_to_eo_open' as const;
export const EO_BRANCH_CTA_VIEW_TO_EO_DISMISSAL = 'eo_branch_cta_view_to_eo_dismissal' as const;
export const EO_BRANCH_CTA_VIEW_TO_PURCHASE = 'eo_branch_cta_view_to_PURCHASE' as const;
export const EO_BRANCH_CTA_VIEW_TO_ADD_TO_CART = 'eo_branch_cta_view_to_ADD_TO_CART' as const;
export const EO_BRANCH_CTA_VIEW_TO_ADD_TO_WISHLIST = 'eo_branch_cta_view_to_ADD_TO_WISHLIST' as const;
export const EO_BRANCH_CTA_VIEW_TO_VIEW_CART = 'eo_branch_cta_view_to_VIEW_CART' as const;
export const EO_BRANCH_CTA_VIEW_TO_INITIATE_PURCHASE = 'eo_branch_cta_view_to_INITIATE_PURCHASE' as const;
export const EO_BRANCH_CTA_VIEW_TO_ADD_PAYMENT_INFO = 'eo_branch_cta_view_to_ADD_PAYMENT_INFO' as const;
export const EO_BRANCH_CTA_VIEW_TO_SPEND_CREDITS = 'eo_branch_cta_view_to_SPEND_CREDITS' as const;
export const EO_BRANCH_CTA_VIEW_TO_RESERVE = 'eo_branch_cta_view_to_RESERVE' as const;
export const EO_BRANCH_CTA_VIEW_TO_CLICK_AD = 'eo_branch_cta_view_to_CLICK_AD' as const;
export const EO_BRANCH_CTA_VIEW_TO_VIEW_AD = 'eo_branch_cta_view_to_VIEW_AD' as const;

export const COST_CALCULATIONS_IN_DEFAULT_CURRENCY = [CALCULATED_ECPA, CALCULATED_ECPC, CALCULATED_ECPI, CALCULATED_ECPM];

export const COST_CALCULATIONS_IN_LOCAL_CURRENCY = [
  CALCULATED_ECPA_IN_LOCAL_CURRENCY,
  CALCULATED_ECPC_IN_LOCAL_CURRENCY,
  CALCULATED_ECPI_IN_LOCAL_CURRENCY,
  CALCULATED_ECPM_IN_LOCAL_CURRENCY,
];

export const COST_CALCULATIONS = [...COST_CALCULATIONS_IN_DEFAULT_CURRENCY, ...COST_CALCULATIONS_IN_LOCAL_CURRENCY];

export const REVENUE_CALCULATIONS = [CALCULATED_ROAS, CALCULATED_ROI];

export const CLICK_TO_EVENT_CALCULATIONS = [
  EO_CLICK_TO_EO_INSTALL,
  EO_CLICK_TO_EO_REINSTALL,
  EO_CLICK_TO_EO_OPEN,
  EO_CLICK_TO_EO_WEB_SESSION_START,
];

export const VIEW_TO_EVENT_CALCULATIONS = [
  EO_BRANCH_CTA_VIEW_TO_EO_CLICK,
  EO_BRANCH_CTA_VIEW_TO_EO_INSTALL,
  EO_BRANCH_CTA_VIEW_TO_EO_OPEN,
  EO_BRANCH_CTA_VIEW_TO_EO_DISMISSAL,
  EO_BRANCH_CTA_VIEW_TO_PURCHASE,
  EO_BRANCH_CTA_VIEW_TO_ADD_TO_CART,
  EO_BRANCH_CTA_VIEW_TO_ADD_TO_WISHLIST,
  EO_BRANCH_CTA_VIEW_TO_VIEW_CART,
  EO_BRANCH_CTA_VIEW_TO_INITIATE_PURCHASE,
  EO_BRANCH_CTA_VIEW_TO_ADD_PAYMENT_INFO,
  EO_BRANCH_CTA_VIEW_TO_SPEND_CREDITS,
  EO_BRANCH_CTA_VIEW_TO_RESERVE,
  EO_BRANCH_CTA_VIEW_TO_CLICK_AD,
  EO_BRANCH_CTA_VIEW_TO_VIEW_AD,
];
